module.exports = __webpack_public_path__ + "img/63.4f1fc6a5.jpg";